export const apiUrl = `${import.meta.env.VITE_API_HOST}${import.meta.env.VITE_API_PATH}`
export const apiUrlV2 = `${import.meta.env.VITE_API_HOST}${import.meta.env.VITE_API_2_PATH}`
export const actionCableUrl = import.meta.env.VITE_ACTIONCABLE_URL